;(function () {
  angular
    .module('contrast.auth')
    .controller('UserRolesMenuCtrl', UserRolesMenuCtrl)

  function UserRolesMenuCtrl(
    $scope,
    $location,
    $window,
    $log,
    $timeout,
    $route,
    $rootScope,
    permissions,
    ProfileFactory,
    AuthFactory,
    pendoService,
    ErrorService,
    UserService,
    URLHistoryService,
    AuthService,
    ProfileService,
    ADMIN_PORTAL_URL,
    ORGANIZATION_SWITCH_EVENT
  ) {
    'ngInject'

    var isAdminPortal = AuthService.isAdminPortal()

    angular.extend($scope, {
      toggleEnabled: isToggleEnabled(),
      adminRole: getAdminRole(),
      showRoleMenu: setShowRoleMenu(),
      hasPermission: hasPermission
    })

    angular.extend($scope, {
      togglePortal: togglePortal,
      switchOrg: switchOrg,
      navigateToNewUi: navigateToNewUi
    })

    function togglePortal(org) {
      var orgUuid = org ? org.organization_uuid : undefined
      return AuthFactory.togglePortal(isAdminPortal, orgUuid).then(function () {
        if (isAdminPortal) {
          $window.location.href =
            '/Contrast/static/ng/index.html#/' +
            org.organization_uuid +
            '/dashboard'
        } else {
          $window.location.href = ADMIN_PORTAL_URL
        }
      }, ErrorService.processError)
    }

    function switchOrg(org) {
      return setDefaultOrg(org).then(function () {
        var url = UserService.buildUrl('/dashboard')
        $location.path(url, false)
        $route.reload()

        $rootScope.$broadcast(ORGANIZATION_SWITCH_EVENT)
        pendoService.initialize(
          ProfileService.getUser(),
          UserService.getCurrentOrganization()
        )
      }, ErrorService.processError)
    }

    function isToggleEnabled() {
      return permissions.isToggleEnabled() && !permissions.isImpersonating()
    }

    function getAdminRole() {
      return permissions.getAdminRole()
    }

    function hasPermission(role) {
      return permissions.hasPermission(role)
    }

    function setDefaultOrg(org) {
      return ProfileFactory.setDefaultOrg(org.organization_uuid).then(function (
        response
      ) {
        var data = response.data.organization
        UserService.setCurrentOrganization(data)
        UserService.setEnterprise(response.data.enterprise)
        permissions.getUserPreferences()
        URLHistoryService.clearPreviousUrl()
      },
      ErrorService.processError)
    }

    function setShowRoleMenu() {
      return isAdminPortal
        ? UserService.showMenu(isAdminPortal)
        : isToggleEnabled() ||
            permissions.isImpersonating() ||
            UserService.showMenu(isAdminPortal)
    }

    function navigateToNewUi() {
      const orgId = $scope.main.currentOrg

      if (!orgId) {
        $log.error('Unable to navigate to new UI, missing orgId')
        return
      }

      if (!$scope.showNavigateToNewUi()) {
        $log.error('Unable to navigate to new UI')
        return
      }

      // Update scope to show loading spinner
      $scope.updateIsNavigatingToNewUi(true)

      $timeout(function () {
        $window.location.href = `/Contrast/cs/index.html#/?orgid=${orgId}`
      }, 750)
    }

    $scope.$on('roles:loaded', function () {
      $scope.toggleEnabled = isToggleEnabled()
      $scope.adminRole = getAdminRole()
      $scope.showRoleMenu = setShowRoleMenu()
    })
  }
})()
